export const routes = [
    {
        linkName: "Product development for startups",
        path: "/product-development-start",
    },
    {
        linkName: "Case studies",
        path: "/case-studies",
    },
    {
        linkName: "Contact us",
        path: "/contact-us",
    },
    {
        linkName: "Product development for enterprises",
        path: "/custom-product-development",
    },
    {
        linkName: "Blog",
        path: "/blog",
    },
    {
        linkName: "Privacy policy",
        path: "/privacy-policy",
    },
    {
        linkName: "Dedicated teams",
        path: "/dedicated-teams",
    },
    {
        linkName: "Careers",
        path: "/careers",
    },
    {
        linkName: "GDPR",
        path: "/gdpr",
    },
    {
        linkName: "About us",
        path: "/about",
    },
    {
        linkName: "Office",
        path: "/office",
    },
];

export const MAIN_BUTTON = "main-button";
export const SECONDARY_BUTTON = "secondary-button";
export const DEFAULT_SIZE_BUTTON = "default-size";
export const SMALL_SIZE_BUTTON = "small-size";

export const NOT_FOUND_PAGE_PATH = "/404";
export const CONTACT_US_PAGE_PATH = "/contact-us";
export const CUSTOM_PRODUCT_DEVELOPMENT = "/custom-product-development";
export const PRODUCT_DEVELOPMENT_START = "/product-development-start";
export const GDPR_PAGE_PATH = "/gdpr";
export const PRIVACY_POLICY_PAGE_PATH = "/privacy-policy";
export const DEDICATED_TEAMS_PAGE_PATH = "/dedicated-teams";
export const THANK_YOU_PATH = "/thank-you";
export const BLOG_PAGE_PATH = "/blog";
export const OFFICE_PATH = "/office";
export const CAREERS_PATH = "/careers";

export const WRAP_LIST = "wrap-list";

export const CATCHUP_SECTION_LEFT = "left";
export const CATCHUP_SECTION_CENTER = "center";

export const CASE_STUDY_TEXT_DEFAULT = "text-default";
export const CASE_STUDY_TEXT_UP = "text-up";
export const CASE_STUDY_TEXT_HIGHER = "text-higher";

export const CASE_STUDY_IMAGE_CENTER = "image-center";
export const CASE_STUDY_IMAGE_DEFAULT = "image-default";

export const HEADER_OFFSET_Y = 55

export const TEXT_SIZE_DEFAULT = "default";
export const TEXT_SIZE_BIG = "big";

export const EMAIL_VALIDATION_REGEXP = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/

export const headerLinks = [
    {
        linkName: "Product development for startups",
        path: "/product-development-start",
        forDesktop: false,
    },
    {
        linkName: "Product development for enterprises",
        path: "/custom-product-development",
        forDesktop: false,
    },
    {
        linkName: "Dedicated teams",
        path: "/dedicated-teams",
        forDesktop: true,
    },
    {
        linkName: "About",
        path: "/about",
        forDesktop: true,
    },
    {
        linkName: "Contact us",
        path: "/contact-us",
        forDesktop: true,
    },
];

export const MOBILE_MAX_WIDTH = 1350;
export const MOBILE_MIN_WIDTH = 767;

// export const MOBILE_MIN_WIDTH = 320;
// export const MOBILE_MAX_WIDTH = 767;
export const TABLET_MIN_WIDTH = 768;
export const TABLET_MAX_WIDTH = 1350;

export const SLIDER_WITH_IMAGES = "slider-with-images";
export const SLIDER_WITH_FEEDBACK = "slider-with-feedback";

export const SHIFTED_IMAGES_COLLAGE = "shifted";
export const UNSHIFTED_IMAGES_COLLAGE = "unshifted";

export const REVERSE_IMAGES_COLLAGE = "reverse-images-collage";
export const DEFAULT_IMAGES_COLLAGE = "default-images-collage";

export const TOOLTIP_ID = "blogToolTip";
export const TOOLTIP_WIDTH = 94;
export const TOOLTIP_HEIGHT = 38;

export const MAC_OS_DESIGNATION = "mac";

export const HURMA_TOKEN = "27d8ee7fb30a3bf492e9c6df79d89df28fb481915001b63a551992bf24b058607c25f0bc95c22ee"
export const EMPTY_VACANCY_ID = 26

export const MIN_ARTICLES_QUANTITY = 5
